import { useEffect, useState } from 'react';
/** Tracks `navigator.onLine`, defaulting to online where the API is unavailable. */
export function useOnlineStatus() {
    // Node has a `navigator` global but no `onLine`, so a plain existence check
    // read as "offline" and put an offline banner into every prerendered page.
    // Anything other than an explicit false is treated as online.
    const [online, setOnline] = useState(() => globalThis.navigator?.onLine !== false);
    useEffect(() => {
        const goOnline = () => setOnline(true);
        const goOffline = () => setOnline(false);
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);
    return online;
}
//# sourceMappingURL=useOnlineStatus.js.map